import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import GridPager from '../../Components/GridPager';
import ResourceGrid from '../../Components/ResourceGrid';
import SortFilter from '../../Components/SortFilter';
import { searchResources } from '../../lib/api';

export const Search = () => {
  const [searchParams] = useSearchParams();
  const sortBy = useMemo<string>(
    () => searchParams.get('sort') || 'relevance',
    [searchParams]
  );
  const currentPage = useMemo<number>(() => {
    return parseInt(searchParams.get('page') || '1');
  }, [searchParams]);

  const { isLoading: searchLoading, data: searchResults } = useQuery({
    queryKey: [
      'search',
      `keywords ${searchParams.get('q') || ''}`,
      `page ${currentPage}`,
      `sort ${sortBy}`,
    ],
    queryFn: () =>
      searchResources(`${searchParams.get('q') || ''}`, currentPage, sortBy),
  });

  return (
    <>
      {searchResults && (
        <div className="search-resources-wrapper">
          <div className="search-info-wrapper">
            <SortFilter sortBy={sortBy} />
          </div>
          <ResourceGrid resources={searchResults.data} />
          <GridPager
            currentPage={currentPage}
            totalResults={searchResults.total}
            pageLength={12}
            baseUrl={`/search?q=${searchParams.get('q') || ''}&sort=${sortBy}`}
          />
        </div>
      )}
      {searchLoading && <BeatLoader color="var(--dark-blue)" />}
    </>
  );
};
